import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { PresidioShellUiFacade } from 'ish-shared/dias/shell-chrome/presidio-shell-ui.facade';

/**
 * CUSTOMIZATION: Presidio checkout chrome — match storefront portal header
 * (utility strip + white brand lockup + Secure checkout + cart), not navy bar.
 * Utility keeps Contact your Presidio team + Help Center (Help next to Alerts removed storefront-side).
 */
@Component({
  selector: 'ish-header-checkout',
  templateUrl: './header-checkout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderCheckoutComponent {
  private checkoutFacade = inject(CheckoutFacade);
  private shellUi = inject(PresidioShellUiFacade);

  readonly itemCount$: Observable<number> = this.checkoutFacade.basketItemCount$;

  openContact(): void {
    this.shellUi.openContact();
  }
}
